import { v4 as uuid } from "uuid";

export const ORDER_SESSION_KEYS = {
  uniqueId: "orderUniqueId",
  shopId: "orderShopId",
  tagId: "orderTagId",
  orderTableId: "orderTableId",
  qrc: "orderQrc",
  currencyCode: "CURRENCY_CODE",
} as const;

const INVALID_STORED_VALUES = new Set(["null", "undefined"]);

export const isValidSessionValue = (value?: string | null): value is string => {
  if (value == null) {
    return false;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 && !INVALID_STORED_VALUES.has(trimmed.toLowerCase());
};

export const getStoredSessionValue = (key: string): string | null => {
  const value = localStorage.getItem(key);
  if (!isValidSessionValue(value)) {
    return null;
  }
  return value.trim();
};

export const setIfChanged = (key: string, value: string) => {
  if (!isValidSessionValue(value)) {
    return;
  }
  if (localStorage.getItem(key) !== value) {
    localStorage.setItem(key, value);
  }
};

export const ensureOrderUniqueId = (): string => {
  const existing = getStoredSessionValue(ORDER_SESSION_KEYS.uniqueId);
  if (existing) {
    return existing;
  }

  const id = Array.from({ length: 4 }, () => uuid()).join("");
  localStorage.setItem(ORDER_SESSION_KEYS.uniqueId, id);
  return id;
};

export type OrderSessionUrlParams = {
  shopId?: string | null;
  tagId?: string | null;
  qrc?: string | null;
  orderTableId?: string | null;
};

export const syncOrderSessionFromUrl = ({
  shopId,
  tagId,
  qrc,
  orderTableId,
}: OrderSessionUrlParams): void => {
  if (isValidSessionValue(shopId)) {
    setIfChanged(ORDER_SESSION_KEYS.shopId, shopId);
  }
  if (isValidSessionValue(tagId)) {
    setIfChanged(ORDER_SESSION_KEYS.tagId, tagId);
  }
  if (isValidSessionValue(qrc)) {
    setIfChanged(ORDER_SESSION_KEYS.qrc, qrc);
  }
  if (isValidSessionValue(orderTableId)) {
    setIfChanged(ORDER_SESSION_KEYS.orderTableId, orderTableId);
  }
};
